import { nextTick, reactive, ref } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import { Bus, useTour } from '@orion.ui/orion';
import { ORDER_STATUS } from '@/typings/enums/ORDER_STATUS';

type Props = SetupProps<typeof TourOrderDetailsAgencySetupService.props>

export default class TourOrderDetailsAgencySetupService extends BaseSetupService<Props> {
	static readonly props = undefined;

	readonly _tourOrderDetailsAgency = ref<OrionTour>();

	private readonly state = reactive({
		canCancel: false,
		canValidate: false,
		canUpdate: true,
	});

	get canCancel () { return this.state.canCancel; }
	get canValidate () { return this.state.canValidate; }
	get canUpdate () { return this.state.canUpdate; }

	constructor (props?: Props) {
		super(props);
	}

	protected onMounted () {
		super.onMounted();
		useTour('tourOrderDetailsAgency', this._tourOrderDetailsAgency.value);
		this.registerBusEvent('tour-order-details-agency', (payload) => {
			nextTick(() => {
				this.state.canCancel = payload.order.status !== ORDER_STATUS.Validated && payload.canUpdate;
				this.state.canValidate = payload.order.status !== ORDER_STATUS.Canceled && payload.order.status !== ORDER_STATUS.Validated && payload.canUpdate;
				this.state.canUpdate = payload.canUpdate;
			});
		});
	}

	openDiscussion () {
		Bus.emit('OrderDetailsSetupService:openDiscussion');
		useTour('tourOrderDetailsAgency').stop();
	}

	async launchPipelineTourAsync () {
		if (this.route.params.section !== 'pipeline') {
			this.router.push({
				name: 'OrderDetailsPipeline',
				params: { id: this.route.params.id },
			});
		}

		useTour('tourOrderDetailsAgency').stop();
		useTour('tourOrderPipeline').start();
	}

	async launchCandidateTourAsync () {
		if (this.route.params.section !== 'candidates') {
			this.router.push({
				name: 'OrderDetailsStatus',
				params: { id: this.route.params.id },
			});
		}
		useTour('tourOrderDetailsAgency').stop();
		useTour('tourOrderStatus').start();
	}
}
